import React from 'react';
import { Typography } from 'antd';
import formatRelativeTime from '../../utilities/time/formatRelativeTime';

const { Text } = Typography;

interface RelativeTimeProps {
  date: number | null;
  locale?: string;
}

const RelativeTime = function ({ date, locale = 'en' }: RelativeTimeProps) {
  return (
    <Text type="secondary">
      {formatRelativeTime(date || new Date().getTime(), locale)}
    </Text>
  );
};

export default RelativeTime;
